export const defaultLightVideos = [];
